import { Box, SxProps, Theme } from "@mui/material";
import { CONTROL_LABEL_SX } from "../../utils/control_label";

export const DateHierarchy = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  column: string;
  setColumn: (column: string) => void;
  columns: { name: string; caption: string }[];
}) => {
  const { sx, column, setColumn, columns, isLoading } = props;

  const columnValid = columns.some((c) => c.name === column);

  return (
    <Box sx={sx}>
      <Box sx={CONTROL_LABEL_SX}>Display by</Box>
      <Box sx={{ display: "flex", gap: "6px" }}>
        {columns.map((c) => {
          const active = columnValid && c.name === column;
          return (
            <Box
              key={c.name}
              component="button"
              type="button"
              disabled={isLoading}
              onClick={() => setColumn(c.name)}
              sx={{
                flex: 1,
                padding: "6px 0",
                borderRadius: "5px",
                fontSize: 12,
                fontWeight: active ? 600 : 500,
                cursor: isLoading ? "default" : "pointer",
                textAlign: "center",
                border: "1px solid",
                borderColor: active
                  ? (t) => t.palette.atomic.brandBlue
                  : (t) => t.palette.atomic.border,
                backgroundColor: active
                  ? (t) => t.palette.atomic.blue1
                  : "#fff",
                color: active
                  ? (t) => t.palette.atomic.brandBlueDark
                  : (t) => t.palette.atomic.inkSecondary,
                "&:hover": isLoading
                  ? {}
                  : { borderColor: (t) => t.palette.atomic.brandBlue },
              }}
            >
              {c.caption}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
